import React from 'react';
import App from './index.js';
import { Router, Route, useRouterHistory } from 'react-router';
import { Provider } from 'react-redux';
import { createHistory, useBasename } from 'history';
// import Login from 'containers/App/screens/Login/router';
const history = useRouterHistory(useBasename(createHistory))({
  basename: '/',
});

export default function createRootRouter(store, moduleRouter) {
  return (
    <Provider store={ store }>
      <Router onUpdate={() => window.scrollTo(0, 0)} history={ history }>
        <Route path="/" component={App}>
          {/* foundation 1.7 9.0 待需求再開時加回 */}
          {/* Login */}
          {moduleRouter}
        </Route>
      </Router>
    </Provider>
  );
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/createRootRouter.js
 **/